import type { ClientOverviewBootstrapEntity } from "../../domain/entities/ClientOverviewBootstrapEntity";

let bootstrapData: ClientOverviewBootstrapEntity | null = null;
let bootstrapPromise: Promise<ClientOverviewBootstrapEntity> | null = null;
let bootstrapError: string | null = null;

export function setClientOverviewBootstrapData(
  data: ClientOverviewBootstrapEntity | null,
): void {
  bootstrapData = data;
}

export function getClientOverviewBootstrapData(): ClientOverviewBootstrapEntity | null {
  return bootstrapData;
}

export function setClientOverviewBootstrapPromise(
  promise: Promise<ClientOverviewBootstrapEntity> | null,
): void {
  bootstrapPromise = promise;
}

export function getClientOverviewBootstrapPromise(): Promise<ClientOverviewBootstrapEntity> | null {
  return bootstrapPromise;
}

export function setClientOverviewBootstrapError(error: string | null): void {
  bootstrapError = error;
}

export function getClientOverviewBootstrapError(): string | null {
  return bootstrapError;
}

export function clearClientOverviewBootstrapStore(): void {
  bootstrapData = null;
  bootstrapPromise = null;
  bootstrapError = null;
}
